import React, { useEffect, useState } from 'react';
import './NowPlayingBarMobile.scss';
import SliderPlaying from './SliderPlaying';
import { useDataLayerValue } from '../../../DataLayer';
import firebase from 'firebase';
import { db } from '../../../firebase';
import { Link, useHistory } from 'react-router-dom';
import { ICONS } from '../../../constants/icons';



function NowPlayingBarMobile(props) {
    const [{ user, playing, playing_loading, song_playing, lang, playlist_id_now, playlist_song_love }, dispatch] = useDataLayerValue();
    const [isUpdating, setIsUpdating] = useState(false);
    const [playlistIdNow, setPlaylistIdNow] = useState(playlist_id_now)
    const handlePlaying = () => {
        if (!playing_loading) {
            dispatch({
                type: 'SET_PLAYING',
                playing: !playing
            });
        }

    };
    const notiLang = {
        en: {
            add_song: 'Add to your Love songs.',
            remove_song: 'Remove from your Love songs.',
            should_login_before_love_song: 'Please login before adding songs to your Love songs!'
        },
        vi: {
            add_song: 'Thích bài hát thành công.',
            remove_song: 'Bỏ thích bài hát thành công.',
            should_login_before_love_song: 'Vui lòng đăng nhập trước khi thêm bài hát vào danh sách yêu thích!'
        }
    };
    const handleSaveSongToLibrary = async () => {
        let playlist_song_love_update = [...playlist_song_love];
        const song_playing_id = song_playing.id;
        if (user !== null && isUpdating === false) {
            setIsUpdating(true);
            if (playlist_song_love_update.includes(song_playing_id)) {
                //Remove song in my playlist love
                const indexOfSong = playlist_song_love_update.indexOf(song_playing_id);
                playlist_song_love_update.splice(indexOfSong, 1)
                dispatch({
                    type: 'SET_PLAYLIST_SONG_LOVE',
                    playlist_song_love: playlist_song_love_update
                });
                dispatch({
                    type: 'SET_NOTI',
                    noti: `${lang === 'en' ? notiLang.en.remove_song : notiLang.vi.remove_song}`
                });
                const docDataUpdate = {
                    playlist_love_song: playlist_song_love_update,
                    updated_at: firebase.firestore.Timestamp.now(),
                };
                await db.collection("users").doc(user.user_uid).update(docDataUpdate);
                setIsUpdating(false);
            } else {
                //Add song in my playlist love
                dispatch({
                    type: 'SET_PLAYLIST_SONG_LOVE',
                    playlist_song_love: [...playlist_song_love_update, song_playing_id]
                });
                dispatch({
                    type: 'SET_NOTI',
                    noti: `${lang === 'en' ? notiLang.en.add_song : notiLang.vi.add_song}`
                });
                const docDataUpdate = {
                    playlist_love_song: [...playlist_song_love_update, song_playing_id],
                    updated_at: firebase.firestore.Timestamp.now(),
                };
                await db.collection("users").doc(user.user_uid).update(docDataUpdate);
                setIsUpdating(false);
            }

        } else {
            if(user === null){
                dispatch({
                type: 'SET_NOTI',
                noti: `${lang === 'en' ? notiLang.en.should_login_before_love_song : notiLang.vi.should_login_before_love_song}`
                });
            }
        }

    };
    return (
        <div className="now-playing-bar-container-mobile">
            <div className="now-playing-bar__slider-playing-mobile">
                <SliderPlaying totalTime={song_playing.time} isMobile={true} isMobileShowTime={false} />
            </div>
            <div className="now-playing-bar__left">
                <div className="now-playing__cover-art">
                    <Link to={`/song/${song_playing.id}`} >
                        <img src={song_playing.avatar ? song_playing.avatar : ''} alt="cover-art" />
                    </Link>
                </div>
                <div className="nowplaying-track-link">
                    <div className="ellipsis-one-line">
                        <Link to={`/song/${song_playing.id}`} className="nowplaying-track-link_song">
                            {lang === "en" ? song_playing.name_en : song_playing.name_vi}
                        </Link>
                    </div>
                    <div className="ellipsis-one-line">
                        <Link to={`/song/${song_playing.id}`} className="nowplaying-track-link_singer">
                            {song_playing.singer ? song_playing.singer : ''}
                        </Link>
                    </div>
                </div>
            </div>
            <div className="now-playing-bar__right">
                <div className="control-button-wrapper">
                    <div className="control-button">
                        <button type="button" className="control-button-heart" title="Save to Your Library" onClick={handleSaveSongToLibrary}>
                            {playlist_song_love && playlist_song_love.includes(song_playing.id) ? (<svg role="img" height="24" width="24" viewBox="0 0 16 16" className="fill-heart">
                                <path fill="none" d="M0 0h16v16H0z"></path>
                                <path d="M13.797 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253c-.77.77-1.194 1.794-1.194 2.883s.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195a4.052 4.052 0 001.195-2.883 4.057 4.057 0 00-1.196-2.883z"></path>
                            </svg>) : (<svg role="img" height="24" width="24" viewBox="0 0 16 16">
                                <path fill="currentColor" d="M13.764 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253A4.05 4.05 0 00.974 5.61c0 1.089.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195A4.052 4.052 0 0014.96 5.61a4.057 4.057 0 00-1.196-2.883zm-.722 5.098L8.58 13.048c-.307.36-.921.36-1.228 0L2.864 7.797a3.072 3.072 0 01-.905-2.187c0-.826.321-1.603.905-2.187a3.091 3.091 0 012.191-.913 3.05 3.05 0 011.957.709c.041.036.408.351.954.351.531 0 .906-.31.94-.34a3.075 3.075 0 014.161.192 3.1 3.1 0 01-.025 4.403z"></path>
                            </svg>)
                            }
                        </button>
                    </div>
                </div>
                <div className="control-button-wrapper">
                    <div className="control-button ">
                        <button className=" control-button--play" title="Play" aria-label="Play" onClick={handlePlaying}>
                            {playing_loading ? (<img src={ICONS.loading} className="loading" alt="icon loading" />) : (playing ?
                                (<svg height="24" role="img" width="24" viewBox="0 0 24 24" >
                                    <rect x="5" y="3" width="4" height="18" fill="currentColor"></rect>
                                    <rect x="15" y="3" width="4" height="18" fill="currentColor"></rect>
                                </svg>) :
                                (<svg height="24" role="img" width="24" viewBox="0 0 24 24">
                                    <polygon points="21.57 12 5.98 3 5.98 21 21.57 12" fill="currentColor"></polygon>
                                </svg>))}
                        </button>
                    </div>

                </div>


            </div>
        </div>
    );
}

export default NowPlayingBarMobile;